query allTennisTeams(
  $first: Int,
  $offset: Int,
  $filter: TennisTeamFilter,
  ) {
  teams: allTennisTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      teamMappings: tennisTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
      name
      source
      teamId
    }
    totalCount
  }
}
